import * as Yup from 'yup';

export const validationSchema = Yup.object().shape({
    additionalMessage: Yup.string()
        .max(2000, 'Max 2,000 characters'),
});